import API from "../network/redAPI"

export const fetchIPData = async () => {
    try {
        const ip = await API.getIp();
        if (!ip) {
            throw new Error("Failed to fetch IP data");
        }
        return ip;
    } catch (error) {
        console.error("Error fetching IP info:", error);
        return null;
    }
};